const GA_ID = import.meta.env.VITE_GA_MEASUREMENT_ID;
const CONSENT_KEY = 'salonite365_cookie_consent';

// ── Load GA script into DOM ───────────────────────────────────────────────────
const loadGA = () => {
  if (!GA_ID || window.__ga_loaded) return;
  window.__ga_loaded = true;

  const script = document.createElement('script');
  script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_ID}`;
  script.async = true;
  document.head.appendChild(script);

  window.dataLayer = window.dataLayer || [];
  window.gtag = function () { window.dataLayer.push(arguments); };
  window.gtag('js', new Date());
  window.gtag('config', GA_ID, {
    anonymize_ip: true,           // GDPR — anonymize IPs
    send_page_view: true,
  });
};

// ── Revoke GA consent (user withdraws) ───────────────────────────────────────
const revokeGA = () => {
  if (!GA_ID) return;
  window.gtag?.('consent', 'update', {
    analytics_storage: 'denied',
  });
};

// ── Check stored consent on initial load ─────────────────────────────────────
export const initAnalytics = () => {
  if (!GA_ID) return;

  try {
    const stored = localStorage.getItem(CONSENT_KEY);
    if (!stored) return;
    const consent = JSON.parse(stored);
    if (consent.analytics === true) loadGA();
  } catch {
    // malformed consent — do nothing
  }

  if (!window.__consent_listener_registered) {
    window.__consent_listener_registered = true;
    window.addEventListener('cookie-consent-updated', (e) => {
      if (e.detail?.analytics === true) {
        loadGA();
      } else {
        revokeGA();
      }
    });
  }
};

// ── Track page views (call on route change) ───────────────────────────────────
export const trackPageView = (path) => {
  if (!window.gtag || !GA_ID) return;
  window.gtag('event', 'page_view', {
    page_path: path,
  });
};

// ── Track custom events ───────────────────────────────────────────────────────
export const trackEvent = (eventName, params = {}) => {
  if (!window.gtag || !GA_ID) return;
  window.gtag('event', eventName, params);
};